export const localeToDashCase = (locale:string | undefined):string => {
  let temp = locale || 'es'

  if (temp.length == 2) return temp
  if (temp.length == 4) {
    temp = temp.toLowerCase()
    const string1 = temp.slice(0,2)
    const string2 = temp.slice(2)
    
    return `${string1}-${string2}`
  }

  return temp
}